import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DriftDashboardRow {
  hostname: string;
  groupName: string;
  issueCount: number;
  currentValue?: any;
  deviceValue?: any;
  asaValue?: any;
  expectedValue?: any;
  goldValue?: any;
  [key: string]: any;
}

export interface DriftDetailRow {
  hostname?: string;
  groupName?: string;
  issueCount?: number;
  label?: string;
  identifier?: string;
  objectName?: string;
  currentValue?: any;
  expectedValue?: any;
  deviceValue?: any;
  asaValue?: any;
  goldValue?: any;
  [key: string]: any;
}

export interface DriftGroupMemberRow extends DriftDetailRow {
  objectType?: string;
}

@Injectable({ providedIn: 'root' })
export class CompareService {
  //url = 'http://localhost:3000';
  url = environment.apiConfig.baseUrl;
  // url = 'https://asa-back-dev.musea2.azure.ext.gm.com';
  

  private readonly comparePath = '/enac/compare';

  constructor(private readonly http: HttpClient) {}

  getDriftDashboard(includeZeroDifferences = false): Observable<DriftDashboardRow[]> {
    let params = new HttpParams();
    if (includeZeroDifferences) {
      params = params.set('includeZeroDifferences', 'true');
    }

    return this.http.get<DriftDashboardRow[]>(`${this.url}${this.comparePath}/dashboard`, { params });
  }

  getDriftDetailsByHostname(hostname: string, includeZeroDifferences = false): Observable<DriftDetailRow[]> {
    const encodedHostname = encodeURIComponent(hostname);
    const url = `${this.url}${this.comparePath}/dashboard/${encodedHostname}`;
    const params = includeZeroDifferences ? new HttpParams().set('includeZeroDifferences', 'true') : undefined;
    const options: { params?: HttpParams } = params ? { params } : {};
    return this.http.get<DriftDetailRow[]>(url, options);
  }

  getGroupMemberDrift(hostname: string, groupNames: string | string[]): Observable<DriftGroupMemberRow[]> {
    const normalizedGroups = Array.isArray(groupNames)
      ? groupNames.filter(Boolean)
      : [groupNames].filter(Boolean);

    if (!normalizedGroups.length) {
      throw new Error('At least one group name is required to load group member drift.');
    }

    const encodedHostname = encodeURIComponent(hostname);
    const params = new HttpParams().set('groupNames', normalizedGroups.join(','));
    const url = `${this.url}${this.comparePath}/dashboard/${encodedHostname}/groups`;
    return this.http.get<DriftGroupMemberRow[]>(url, { params });
  }
}
